/**
 * Ключ канала: по какой ссылке человек пришёл.
 *
 * Живёт в адресе (`?k=…`) и запоминается на время сессии: человек нажал на
 * баннер, попал на акцию, ушёл ввести код — и ключ должен доехать до гашения,
 * иначе обещанная надбавка не начислится и выйдет обман, которого никто не
 * хотел.
 *
 * Хранится по акции, а не одним значением: открыв две акции по двум разным
 * баннерам, человек не должен получать условие одной в другой. Срок —
 * сессия: вкладку закрыли, ссылку забыли. Долгое хранение означало бы, что
 * условие прошлогоднего баннера всплывает через полгода.
 */
const KEY = 'allswipes.link.';
const LAST = 'allswipes.link.last';

export function rememberLink(campaignId: string, key: string | null) {
  if (!campaignId || !key) return;
  try {
    sessionStorage.setItem(KEY + campaignId, key);
    sessionStorage.setItem(LAST, key);
  } catch {
    // Приватный режим или заблокированное хранилище: ключ просто не
    // запомнится, участие от этого не ломается.
  }
}

export function linkFor(campaignId: string): string | undefined {
  try {
    return sessionStorage.getItem(KEY + campaignId) ?? undefined;
  } catch {
    return undefined;
  }
}

/**
 * Последняя ссылка, по которой человек приходил.
 *
 * Нужна экрану сканирования: акцию там определяет код, а не экран, и какой
 * именно ключ прикладывать, приложение заранее не знает. Отправлять
 * последний безопасно: сервер начисляет надбавку, только если канал
 * принадлежит той самой акции, чей код погашен, — чужой ключ он молча
 * игнорирует, не мешая участию.
 */
export function lastLink(): string | undefined {
  try {
    return sessionStorage.getItem(LAST) ?? undefined;
  } catch {
    return undefined;
  }
}

/**
 * Запомнить ключ, когда акция из адреса не следует.
 *
 * Такое бывает на экране сканирования: туда приходят с ключом, а какая акция
 * — решит код. Сервер всё равно проверит, что канал принадлежит той самой
 * акции, чей код погашен.
 */
export function rememberLast(key: string | null) {
  if (!key) return;
  try {
    sessionStorage.setItem(LAST, key);
  } catch {
    // Хранилище заблокировано — надбавка просто не начислится.
  }
}
